import type { ComponentProps } from 'react'

import { cn } from '@/lib/utils'

/** A shadcn-style loading placeholder: a pulsing, rounded translucent block. */
function Skeleton({ className, ...props }: ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn('animate-pulse rounded-md bg-foreground/10', className)}
      {...props}
    />
  )
}

export { Skeleton }
